import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'next/router';

import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import FlexBox from '../FlexBox';

const navs = [
  { url: '/about', name: 'exchange-aboutNav-about', aboutTitleId: 'aboutNav-a-about' },
  { url: '/career', name: 'exchange-aboutNav-careers', aboutTitleId: 'aboutNav-a-careers' },
  // { url: '/ecosystem', name: 'exchange-aboutNav-ecosystem', aboutTitleId: 'aboutNav-a-ecosystem'  },
  { url: '/press', name: 'exchange-aboutNav-press', aboutTitleId: 'aboutNav-a-press' },
  { url: '/community', name: 'exchange-aboutNav-community', aboutTitleId: 'aboutNav-a-community' },
];

const WrapperBox = styled(FlexBox)`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 55;
  padding: 20px 0;
  background: rgba(11, 14, 17, 0.5);
  transition: all 0.5s;
  &.fixBox {
    position: fixed;
    background: rgba(10, 13, 16, 0.96);
  }
`;
const Nav = styled(FlexBox)`
  position: relative;
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  justify-content: center;
`;
const NavItem = styled.div`
  float: left;
  height: 34px;
  line-height: 34px;
  margin-right: 40px;
  &:last-child {
    margin-right: 0;
  }
  &.brand {
    position: absolute;
    height: 34px;
    top: 0;
    left: 0;
    font-size: 20px;
    color: #fff;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
  > a {
    font-family: ${({ theme }) => theme.fontIBMMedium};
    font-weight: 600;
    color: #a1a1a3;
    font-size: 14px;
    &:hover,
    &.active {
      color: #fff;
    }
  }
`;

type Props = {
  locale: string,
  i18n: Object,
  router: Object,
};

type States = {
  activePathname: string,
  scrollScale: boolean,
};

export default
@withI18n
@withRouter
class AboutNav extends React.Component<Props, States> {
  static defaultProps = {
    locale: 'en',
    i18n: {},
    router: { pathname: '' },
  };

  constructor(props: Props) {
    super(props);
    const { curModule } = this._getRouterInfo();
    this.state = {
      activePathname: curModule,
      scrollScale: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll);
    if (
      (document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop) >= 8
    ) {
      this.setState({ scrollScale: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll);
  }

  _getRouterInfo = () => {
    const {
      router: { pathname },
    } = this.props;
    const curModule = pathname.split('/')[1];
    return {
      curModule: `/${curModule}`,
    };
  };

  _handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    const { scrollScale } = this.state;
    if (scrollTop >= 60) {
      !scrollScale && this.setState({ scrollScale: true });
    } else {
      scrollScale && this.setState({ scrollScale: false });
    }
  };

  render() {
    const { i18n, locale } = this.props;
    const { activePathname, scrollScale } = this.state;
    return (
      <WrapperBox direction="column" className={scrollScale && 'fixBox'}>
        <Nav>
          <NavItem className="brand">{getLabel('exchange-aboutNav-aboutBinance', i18n)}</NavItem>
          <div>
            {navs.map(({ url, name, aboutTitleId }) => (
              <NavItem key={name}>
                <a
                  id={aboutTitleId}
                  key={name}
                  href={`/${locale}${url}`}
                  className={url === activePathname ? 'active' : null}
                >
                  {getLabel(name, i18n)}
                </a>
              </NavItem>
            ))}
          </div>
        </Nav>
      </WrapperBox>
    );
  }
}
